import React, {useEffect, useState} from 'react';
import {observer} from 'mobx-react';
import {FoundGamesComponent} from "./found-games/found-games.component";
import {SuggestedLinksComponent} from "./suggested-links/suggested-links.component";
import {SearchFormResultsBox} from "./boxes/search-form-results-box/search-form-results.box";
import {SearchFormResultsWrapperBox} from "./boxes/search-form-results-wrapper-box/search-form-results-wrapper.box";
import {SuggestedGamesComponent} from './suggested-games/suggested-games.component';
import {
    OrbitUserFlowAnalyticsCategory,
    OrbitUserFlowAnalyticsLabel
} from "../../../services/analytics/analytics.service.interface";
import {ComponentServicesPick} from "../../../services/component-services-pick";
import {reaction} from "mobx";
import {useServices} from "../../../react-hooks/use-services.hook";
import {withServices} from "../../../react-hooks/with-services";
import {SuggestedVideoSlidesFilterListPreviewComponent} from './suggested-video-slides-filter-list-preview/suggested-video-slides-filter-list-preview.component';

const LOAD_BATCH_SIZE = 12;


interface SearchResultComponentProps extends ComponentServicesPick<'gameSearch'> {

}

const ComponentBody: React.FC<SearchResultComponentProps> = observer((props) => {
    const services = useServices();
    const [loadedGames, setLoadedGames] = useState(LOAD_BATCH_SIZE);

    useEffect(() => {
        const r = reaction(() => props.gameSearch.currentSearchText, () => {
            setLoadedGames(LOAD_BATCH_SIZE);
        });

        return () => r();
    }, [props.gameSearch.currentSearchText]);


    if (!props.gameSearch.isSearchBoxOpened) {
        return null;
    }

    const _onLoadMore = () => {
        services.analytics.sendOrbitUserFlowEvent(OrbitUserFlowAnalyticsCategory.Search, 'Entry', OrbitUserFlowAnalyticsLabel.ShowMore);
        const moreItems = Math.min(loadedGames + LOAD_BATCH_SIZE, props.gameSearch.searchResult.games.length);
        setLoadedGames(moreItems);
    }


    const renderSuggestedVideoSlidesFilterListPreview = () => {
        if (services.videoSlides.shouldBeDisplayed) {
            return (<SuggestedVideoSlidesFilterListPreviewComponent items={props.gameSearch.searchResult.suggestedVideoSlidesFilterListPreview} />)
        }

        return null;
    }

    const _renderSearchResults = () => {
        if (props.gameSearch.isSearchInProgress) {
            return (
                <>
                    <FoundGamesComponent loadedGamesCount={loadedGames} onLoadMore={_onLoadMore} />
                    {services.miniOrbit.isEnabled ? null : <SuggestedLinksComponent title={'SUGGESTED_CATEGORIES'} className={'cy-suggested-links-suggested-links'} items={props.gameSearch.searchResult.suggestedCategories} />}
                </>
            );
        } else {
            return (
                <>
                    {renderSuggestedVideoSlidesFilterListPreview()}
                    <SuggestedGamesComponent items={props.gameSearch.searchResult.suggestedGames} />
                    {services.miniOrbit.isEnabled ? null : <SuggestedLinksComponent title={'QUICK_LINKS_TITLE'} className={'cy-suggested-links-quick-links'} items={props.gameSearch.searchResult.suggestedCategories} />}
                </>
            );
        }
    }



    const isHybridAndroid = services.device.hybrid.isHybrid && !services.device.os.isIOS;

    return (
        <SearchFormResultsBox isHybridAndroid={isHybridAndroid && services.mediaQuery.portrait} ref={props.gameSearch.searchResultComponentRef}>
            <SearchFormResultsWrapperBox>
                {_renderSearchResults()}
            </SearchFormResultsWrapperBox>
        </SearchFormResultsBox>
    );

})

export const SearchResultComponent = withServices(ComponentBody, ['gameSearch']);